import { takeEvery } from '@pressreader/appstore';
import { openAlertOk } from '@pressreader/popups-alert';
import { localizedString } from '@pressreader/resources';

import { checkIssueReadLimitsAction } from '../actions';

function* onCheckIssueReadLimits(action: ReturnType<typeof checkIssueReadLimitsAction>) {
    const limits = action.payload;
    if (!limits) {
        return;
    }
    let message: string | null = null;
    if (limits.hasReachedDailyIssueReadLimit) {
        message = localizedString('ReadLimit.DailyLimitExceeded');
    } else if (limits.hasReachedIssueReadLimit) {
        message = localizedString('ReadLimit.IssuesHardLimitExceeded');
    } else if (limits.hasIssueReadLimitReachingWarning) {
        message = localizedString('ReadLimit.IssuesSoftLimitExceeded');
    }
    if (message) {
        yield openAlertOk({ message });
    }
}

export function* saga() {
    yield takeEvery(checkIssueReadLimitsAction, onCheckIssueReadLimits);
}
